/**
 * Portal session token (MIRA 2.0)
 *
 * MIRA returns a session token from POST /portal/session, and every call sends it
 * in the X-Portal-Session header. A cookie does not work: Relesys shows the portal
 * in an iframe on its own site, where the browser blocks MIRA's SameSite=Lax cookie.
 *
 * The token lives in sessionStorage so a reload inside the iframe keeps the session.
 * Some browsers block storage in third-party iframes; then it lives in memory only,
 * and a reload means opening the portal again from the app.
 */

const STORAGE_KEY = 'portal_session';

let memoryToken: string | null = null;

export function getPortalSession(): string | null {
  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY);
    if (stored) return stored;
  } catch {
    // Storage blocked: fall back to memory.
  }
  return memoryToken;
}

export function setPortalSession(token: string): void {
  memoryToken = token;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, token);
  } catch {
    // Storage blocked: the in-memory copy is enough for this page view.
  }
}

export function clearPortalSession(): void {
  memoryToken = null;
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage blocked: nothing stored there.
  }
}
